/* tkf-runtime v3 — 2026-10-14 */
/* Takumi™ — poraštės elgsena.

   Vietos sticky juostai čia nebeskaičiuojama. Buvo: matavimas kiekvieno
   slinkimo metu, keitęs poraštės apatinį tarpą. Juostai dingus ar vėl
   pasirodžius tarpas šokteldavo, puslapio ilgis pasikeisdavo, ir naršyklė
   permesdavo slinkimą aukštyn — greitai slenkant puslapio galo pasiekti
   nepavykdavo. Vietą dabar palieka stilius viena pastovia reikšme, kuri
   niekada nesikeičia, tad puslapio ilgis stovi vietoje.
   Savarankiška: nesidalina niekuo su kitų puslapių scenarijais. Įsirašo vieną
   kartą, kad ir kiek kartų sekcija pakviestų scenarijų. */
(function () {
  'use strict';
  if (window.TKF) return;
  var TKF = (window.TKF = {});
  TKF.version = '2026-10-14-footer-v3';

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ----------------------------------------------------------- stulpeliai
     Telefone kiekvienas stulpelis tampa išskleidžiamu. Suskleidimą valdo
     stilius, bet tik tada, kai čia pažymima, kad scenarijus veikia — kitaip
     puslapis be JavaScript'o liktų su nuorodomis, kurių neatidarysi.

     Pirmasis stulpelis paliekamas atviras: taip iš karto matyti, kad eilutės
     spaudžiamos, ir nereikia spėlioti. */
  function bindColumns() {
    $$('[data-tkf]').forEach(function (root) {
      if (root._tkfCols) return;
      root._tkfCols = true;
      var cols = $$('[data-tkf-col]', root);
      if (!cols.length) return;
      root.setAttribute('data-tkf-acc', 'true');

      cols.forEach(function (col, i) {
        var btn = col.querySelector('[data-tkf-col-btn]');
        var panel = col.querySelector('[data-tkf-col-body]');
        if (!btn || !panel) return;
        var open = i === 0;
        col.setAttribute('data-open', open ? 'true' : 'false');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');

        var sign = btn.querySelector('.tkf-col-sign');

        btn.addEventListener('click', function () {
          /* Kompiuteryje antraštė nieko neslepia, tad ir spaudimas neturi
             nieko daryti — kitaip pelės brūkštelėjimas per pavadinimą
             netyčia paslėptų visą stulpelį.

             Klausiama ne lango pločio, o paties pliuso ženklo: suskleidimą
             įjungia konteinerio užklausa, tad ženklas matomas lygiai tada,
             kai stulpeliai suskleisti. Lango plotis būtų atskiras matas, ir
             tą dieną, kai poraštė atsidurtų siauresniame stulpelyje, stilius
             nuorodas paslėptų, o scenarijus atsisakytų jas atidaryti. */
          if (!sign || getComputedStyle(sign).display === 'none') return;
          var now = col.getAttribute('data-open') === 'true';
          col.setAttribute('data-open', now ? 'false' : 'true');
          btn.setAttribute('aria-expanded', now ? 'false' : 'true');
        });
      });
    });
  }

  /* ------------------------------------------------------- naujienlaiškis
     Shopify po išsiuntimo perkrauna puslapį ir grąžina žmogų į patį viršų,
     o pranešimas lieka poraštėje, kurios jis nebemato. Todėl prie sėkmės ar
     klaidos puslapis pats nuslenka atgal prie formos. */
  function bindForm() {
    var flag = document.querySelector('[data-tkf-scroll]');
    if (!flag) return;
    var target = flag.closest('[data-tkf-news]') || flag;
    requestAnimationFrame(function () {
      var y = target.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });
  }

  function init() {
    bindColumns();
    bindForm();
    /* Redaktorius perpiešia po vieną sekciją neperkraudamas puslapio. */
    document.addEventListener('shopify:section:load', function () {
      bindColumns();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
